import { LiveUpdaterClient } from 'app/scripts/init/live-updater-client';

export const classicUpdaterClient = new LiveUpdaterClient();
